import { optionsForDate } from "../GanttInfoRenderer";
import { AbstractInfoRenderer } from "./AbstractInfoRenderer";;

export class HumanResourceScheduleInfoRenderer extends AbstractInfoRenderer {

    static defaultProps = {
        entityName: "HumanResourceSchedule"
    }

    renderContent() {
        const { entity } = this.props;
        const ed = this.getEntityDescriptor();
        return <div className="flex-container-row gap5">
            {ed.getField("startTime").renderField(entity, optionsForDate)}
            {ed.getField("endTime").renderField(entity, optionsForDate)}
        </div>
    }
}
